import {
  ETransactionOwnerType,
  TTransaction,
  TransactionsFilterQuerySchema,
} from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const getTransactions = (axios: IAxiosInstance) => {
  return async ({
    limit,
    ...filters
  }: TransactionsFilterQuerySchema & {
    companyID: string;
    limit?: number;
    owner_type: ETransactionOwnerType;
  }) => {
    const response = await axios.noRetry.get<IApiResponse<TTransaction[]>>(
      `/transactions`,
      {
        params: {
          ...filters,
          limit,
        },
      }
    );

    return response.data;
  };
};
